
export class StringHelper {

  static format(myString: string, ...parametersValues: any[]): string {
    if (!myString) {
      return "";
    }

    const parts = myString.split("{");
    parts.shift(); // remove first element

    //For each parameter in the string, replace the ones for which a value was given
    for (let i = 0; i < parts.length; i++) {
      const index = parts[i][0];
      if (parametersValues[index] != null) {
        const currentParameter = "{" + index + "}";
        myString = myString.replace(currentParameter, parametersValues[index]);
      }
    }

    return myString;

  }

  static getImageHttpsUrl(url: string) {
    //for itunes
    url = url.replace(/http:\/\/is[0-9]\./, "https://is5-ssl.");
    //for amazon
    url = url.replace(/http:\/\/ecx.*amazon.*\.com/, "https://images-eu.ssl-images-amazon.com");
    //for vudu and in general
    url = url.replace(/http:\/\//, "https://");
    return url;
  }

  static upperCaseFirstLetter(string: string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  static lowCaseFirstLetter(string: string) {
    return string.charAt(0).toLowerCase() + string.slice(1);
  }

  static replacePointsWithCommas(value: string): string {
    if (!value){
      return value;
    }
    const strValue: String = new String(value);
    const result = strValue.replace('.', ',');
    return result;
  }

  static slugify(str: string): string {
    if (!str) return '';
    
    // Ensure str is a string type
    if (typeof str !== 'string') {
      str = String(str);
    }
    
    str = str.replace(/^\s+|\s+$/g, ''); // trim

    str = str.replace('&', '');//remove ampersand
    str = str.replace('?', '');//remove question mark

    //German accents
    str = str.replace('ü', "ue");
    str = str.replace('ä', "ae");
    str = str.replace('ö', "oe");
    str = str.replace('ß', "ss");

    // remove other accents, swap ñ for n, etc
    const from = "ãàáäâẽèéëêìíïîõòóöôùúüûñç·/_,:;";
    const to   = "aaaaaeeeeeiiiiooooouuuunc------";
    for (let i = 0, l = from.length ; i < l ; i++) {
      str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
    }

    // Remove invalid chars - use regex object, not string
    // Note: \p{Cyrillic} is not supported in older browsers, so we use a simpler pattern
    str = str.replace(/[^a-zA-Z0-9 -]/g, '')
    .replace(/\s+/g, '-') // collapse whitespace and replace by -
    .replace(/-+/g, '-'); // collapse dashes

    return str;
  }

}
